import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { AddTalentReviewCandidate } from "../../../types/addReviewCandidate";

import RatingTable from "../RatingTable";

const TechnicalSkillsStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tTalentReport } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal.talentReport" });

  const { control } = useFormContext<AddTalentReviewCandidate>();

  const skills: { title: string; description: string; fieldName: keyof AddTalentReviewCandidate }[] = [
    {
      title: tTalentReport("firstTouchReceiving"),
      description: tTalentReport("howWellThePlayerControls"),
      fieldName: "firstTouchReceiving",
    },
    {
      title: tTalentReport("passingRangeAccuracy"),
      description: tTalentReport("abilityToDeliver"),
      fieldName: "passingRangeAccuracy",
    },
    {
      title: tTalentReport("dribbling1v1Ability"),
      description: tTalentReport("skillInBeatingOpponents"),
      fieldName: "dribbling1v1Ability",
    },
    {
      title: tTalentReport("shootingFinishing"),
      description: tTalentReport("shootingFinishing"),
      fieldName: "shootingFinishing",
    },
    {
      title: tTalentReport("crossingDelivery"),
      description: tTalentReport("effectivenessCrossesPasses"),
      fieldName: "crossingDelivery",
    },
    {
      title: tTalentReport("headingTechnique"),
      description: tTalentReport("headingTechnique"),
      fieldName: "headingTechnique",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={skills} control={control} />
    </Box>
  );
};

export default TechnicalSkillsStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
